import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=9803906a"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports